import * as yup from 'yup';

export const createFormSchemas = (t) => {
  const formSchemaNovoEndereco = yup.object().shape({
    isBrasilHidden: yup.boolean().notRequired(),
    sn: yup.boolean().notRequired(),
    identificacao: yup
      .string()
      .typeError(t('principal.addresses.validation.identification_required'))
      .required(t('principal.addresses.validation.identification_required')),
    codigoPostal: yup.string().when('isBrasilHidden', {
      is: true,
      then: yup
        .string()
        .typeError(t('principal.addresses.validation.cep_required'))
        .required(t('principal.addresses.validation.cep_required')),
      otherwise: yup
        .string()
        .typeError(t('principal.addresses.validation.postal_code_required'))
        .required(t('principal.addresses.validation.postal_code_required')),
    }),
    logradouro: yup.string().when('isBrasilHidden', {
      is: false,
      then: yup.string().required(t('principal.addresses.validation.street_required')),
      otherwise: yup.string().notRequired(),
    }),
    bairro: yup.string().when('isBrasilHidden', {
      is: false,
      then: yup.string().required(t('principal.addresses.validation.neighborhood_required')),
      otherwise: yup.string().notRequired(),
    }),
    cidade: yup.string().when('isBrasilHidden', {
      is: false,
      then: yup.string().required(t('principal.addresses.validation.city_required')),
      otherwise: yup.string().notRequired(),
    }),
    uf: yup.string().when('isBrasilHidden', {
      is: false,
      then: yup.string().required(t('principal.addresses.validation.state_required')),
      otherwise: yup.string().notRequired(),
    }),
    numero: yup.string().when('sn', {
      is: false,
      then: yup
        .string()
        .test(
          'valores invalidos',
          t('principal.addresses.validation.no_number_instruction'),
          (value) => {
            if (!value) return true;
            const valoresInvalidos = ['sn', 's/n', 's n', 'sem numero'];
            const valorLowerCase = value.trim().toLowerCase();
            return !valoresInvalidos.includes(valorLowerCase);
          },
        )
        .required(t('principal.addresses.validation.number_required')),
      otherwise: yup.string().notRequired(),
    }),
  });

  const formSchemaAlteraEndereco = yup.object().shape({
    sn: yup.boolean().notRequired(),
    identificacao: yup
      .string()
      .typeError(t('principal.addresses.validation.identification_required'))
      .required(t('principal.addresses.validation.identification_required')),
    numero: yup.string().when('sn', {
      is: false,
      then: yup
        .string()
        .test(
          'valores invalidos',
          t('principal.addresses.validation.no_number_instruction'),
          (value) => {
            if (!value) return true;
            const valoresInvalidos = ['sn', 's/n', 's n', 'sem numero'];
            const valorLowerCase = value.trim().toLowerCase();
            return !valoresInvalidos.includes(valorLowerCase);
          },
        )
        .required(t('principal.addresses.validation.number_required')),
      otherwise: yup.string().notRequired(),
    }),
  });

  return {
    formSchemaNovoEndereco,
    formSchemaAlteraEndereco,
  };
};

// Backward compatibility exports for direct imports
export const formSchemaNovoEndereco = null;
export const formSchemaAlteraEndereco = null;